// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import qs from 'query-string';
import { withRouter } from '../../../../router-compat';
import configs from '../configs';
import { IntegrationLayout, OAuthSetup, ExternalLinkA } from '../_shared';

class HubSpot extends Component {
  componentDidMount() {
    this.props.store.integrations.HubSpot.getConfigs();
    const { code } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    if (code) this.props.store.integrations.HubSpot.getTokens(code);
  }

  render() {
    return (
      <IntegrationLayout config={configs.HubSpot}>
        <OAuthSetup
          partnerKey="HubSpot"
          steps={[
            <>Make a HubSpot account <ExternalLinkA href="https://app.hubspot.com/signup-v2/marketing/step/join-hubspot-account">here</ExternalLinkA> if you don&apos;t have one already.</>,
            'Grant Movology the necessary permissions:',
            'After authorizing, future captures will be added as HubSpot contacts.',
          ]}
        />
      </IntegrationLayout>
    );
  }
}

export default withRouter(inject('store')(observer(HubSpot)));
